<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-button @click="closeInvite">Cancel</ion-button>
        </ion-buttons>
        <ion-title>Invite Collaborator</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="inviteUser">Invite</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item>
          <ion-icon color="tertiary" ios="ios-mail" md="md-mail" slot="start"></ion-icon>
          <ion-label color="primary">Email</ion-label>
          <ion-input type="email" inputmode="email" pattern="email" :value="email" @ionInput="email = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-icon color="tertiary" ios="ios-key" md="md-key" slot="start"></ion-icon>
          <ion-label color="primary">Role</ion-label>
          <ion-select interface="popover" :value="role" @ionChange="role = $event.target.value">
            <ion-select-option value="reader">Reader (read only)</ion-select-option>
            <ion-select-option value="writer">Writer (read and write)</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import User from "../models/User";
import Form from "../models/Form";
export default {
  name: "user-invite",
  mixins: [Helpers],
  props: ["form"],
  data() {
    return {
      role: "reader",
      email: ""
    };
  },
  methods: {
    closeInvite() {
      this.hideModal();
    },
    async inviteUser() {
      if (this.email == undefined || this.email.length == 0) {
        this.showToast("Please enter email address");
      } else if (this.isValidEmail() == false) {
        this.showToast("Please enter valid email address");
      } else if (this.role == undefined || this.role.length == 0) {
        this.showToast("Please select a role");
      } else {
        let loading = await this.showLoading("Inviting...");
        try {
          let invited = await this.form.invite(this.email, this.role);
          loading.dismiss();
          this.showToast(`Invited ${this.email} as ${this.role}`);
          this.hideModal();
        } catch (error) {
          loading.dismiss();
          this.showError("Problem Inviting User", error);
        }
      }
    },
    isValidEmail() {
      if (this.email && this.email.length > 0) {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(this.email).toLowerCase());
      }
      return true;
    }
  }
};
</script>

<style scoped>
</style>